import { render, staticRenderFns } from "./treatmentDetailOrder.html?vue&type=template&id=0a53c603&scoped=true&"
import script from "./treatmentDetailOrder.js?vue&type=script&lang=js&"
export * from "./treatmentDetailOrder.js?vue&type=script&lang=js&"
import style0 from "./treatmentDetailOrder.scss?vue&type=style&index=0&id=0a53c603&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a53c603",
  null
  
)

export default component.exports